<template>
	<TheHeader></TheHeader>

	<div class="container-fluid">
		<div class="container">
			<form name="form">
				<div class="contain row">
					<TheSidebar></TheSidebar>

					<div class="page-container card col-md-8">
						<ThePageHeader @export-event="exportFile" @import-event="importFile" :renderExport="!isLoading" :renderImport="!isLoading" :isExporting="isExporting" :isImporting="isImporting"></ThePageHeader>

						<div class="row" v-if="pageError == ''">

							<div class="row p-3">
								<div class="col-md-6">
									<Button class="p-button-sm" @click="add" label="Create New Conso Group"/>
								</div>
							</div>

							<div class="row p-3 pb-0">
								<label><b>Search existing Conso Group by:</b></label>
							</div>


							<div class="row p-3">
								<div class="col-md-6">
									<InputText class="p-inputtext" type="text" maxlength="100" placeholder="Name" v-model="filterNameModel.value" />
								</div>

								<div class="col-md-6">
									<Dropdown :options="purposes" optionLabel="name" optionValue="identifier" placeholder="Purpose" :loading="isPurposeLoading" v-model="filterPurposeModel.value" />
								</div>
							</div>

							<div class="row p-3">
								<div class="col-md-5 d-flex align-items-center">
									<Button class="p-button-sm" @click="find(1)" label="Search"/>
									<span class="p-1"></span>
									<Button class="p-button-sm p-button-secondary" @click="reset" label="Reset"/>
								</div>

								<div class="col-md-7">
									<Paginator :first="paginator" :pageLinkSize="3" :rows="pagination.itemsPerPage" :totalRecords="pagination.totalItems" @page="find($event.page + 1)" v-if="pagination.currentPage != 0" />
								</div>
							</div>

							<div class="row">
								<div class="col-md-12 p-4">
									<table class="p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12">
										<thead class="p-datatable-thead">
											<tr>
												<th style="width: 8%;">#</th>
												<th style="width: 31%; cursor: pointer;" @click="sort('x.name')">Name <span class="pi" :class="[sortingModel.columnName == 'x.name' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 15%; cursor: pointer;" @click="sort('x.purpose.name')">Purpose <span class="pi" :class="[sortingModel.columnName == 'x.purpose.name' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 23%; cursor: pointer;" @click="sort('x.createdDate')">Creation Date <span class="pi" :class="[sortingModel.columnName == 'x.createdDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
												<th style="width: 23%; cursor: pointer;" @click="sort('x.lastModifiedDate')">Last Action Date <span class="pi" :class="[sortingModel.columnName == 'x.lastModifiedDate' ? (sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']"></span></th>
											</tr>
										</thead>
										<tbody class="p-datatable-tbody" v-if="!isLoading">
											<tr v-for="(consoGroup, index) in pagination.consoGroups" :key="index" v-on:click="view(consoGroup)">
												<td>{{((pagination.currentPage - 1) * pagination.itemsPerPage) + index + 1}}</td>
												<td>{{consoGroup.name}}</td>
												<td>{{consoGroup.purpose.name}}</td>
												<td>{{formatToDateTime(consoGroup.createdDate)}}</td>
												<td>{{formatToDateTime(consoGroup.lastModifiedDate)}}</td>
											</tr>
										</tbody>
									</table>
								</div>

								<div class="error-no-record" v-if="!isLoading && pagination.consoGroups.length == 0">
									<FontAwesomeIcon :icon="['fas', 'image']" size="2x" />
									<h6><span>No Record Found</span></h6>
								</div>

								<TheTableLoading v-if="isLoading"></TheTableLoading>
							</div>
						</div>

						<TheInvalidImportDialog title="Conso Group" :visible="isDialogVisible" :data="invalidData" @close-dialog-event="closeDialog" @proceed-import-event="proceedImport"></TheInvalidImportDialog>

						<ThePageError @back-event="cancel" :pageError="pageError" v-if="pageError != ''"></ThePageError>
					</div>

					<TheFooter></TheFooter>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import store from "@/store";
	import consoGroupApi from "@/api/consogroup-api";
	import purposeApi from "@/api/purpose-api";
	import statusMixin from "@/mixin/status";
	import dateUtilsMixin from "@/mixin/utils/date-utils"

	import TheHeader from "@/components/TheHeader.vue";
	import TheFooter from "@/components/TheFooter.vue";
	import TheSidebar from "@/components/TheSidebar.vue";
	import ThePageHeader from "@/components/ThePageHeader.vue";
	import TheTableLoading from "@/components/TheTableLoading.vue";
	import ThePageError from "@/components/ThePageError.vue";
	import TheInvalidImportDialog from "@/components/TheInvalidImportDialog.vue";
	import companyApi from "@/api/company-api";

	export default defineComponent({
		mixins: [statusMixin, dateUtilsMixin],
		components: {
			TheHeader,
			TheFooter,
			TheSidebar,
			ThePageHeader,
			TheTableLoading,
			ThePageError,
			TheInvalidImportDialog
		},
		data() {
			return {
				pageError: (store.getters.error == undefined ? '' : store.getters.error),
				purposes: [] as any[],
				pagination: (store.getters.getCached.page == null ? {currentPage: 1, itemsPerPage: 10, consoGroups: [], totalItems: 0} : store.getters.getCached.page.pagination),
				sortingModel: (store.getters.getCached.page == null ? {columnName: "x.name", isAscending: true} : store.getters.getCached.page.sortingModel),
				filterNameModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterNameModel),
				filterPurposeModel: (store.getters.getCached.page == null ? {value: ""} : store.getters.getCached.page.filterPurposeModel),
				isLoading: false,
				isPurposeLoading: false,
				isImporting: false,
				isExporting: false,
				isDialogVisible: false,
				invalidData:{} as any
			}
		},
		mounted: function() {
			if (this.pageError == '') {
				this.find(this.pagination.currentPage);

				this.loadPurposeList();
			}
		},
		computed: {
			paginator() {
				return ((this.pagination.currentPage - 1) * this.pagination.itemsPerPage);
			},
		},
		methods: {
			loadPurposeList() {
				this.isPurposeLoading = true;

				purposeApi.purposeList({})
					.then(response=>{
						this.purposes = response.data.listSet;
						this.isPurposeLoading = false;
					})
					.catch(error => {
						this.isPurposeLoading = false;
					});
			},
			sort(columnName: string) {
				if (this.sortingModel.columnName == columnName) {
					this.sortingModel.isAscending = !this.sortingModel.isAscending;
				}

				else {
					this.sortingModel.columnName = columnName;
					this.sortingModel.isAscending = true;
				}
				this.find(1);
			},
			find(page: number) {
				this.isLoading = true;

				store.getters.getCached.page = {
					pagination: JSON.parse(JSON.stringify(this.pagination)),
					sortingModel: JSON.parse(JSON.stringify(this.sortingModel)),
					filterNameModel: JSON.parse(JSON.stringify(this.filterNameModel)),
					filterPurposeModel: JSON.parse(JSON.stringify(this.filterPurposeModel)),
				};

				consoGroupApi.consoGroupFind({
						paginationModel: {currentPage: page},
						sortingModel: this.sortingModel,
						filterNameModel: this.filterNameModel,
						filterPurposeModel: this.filterPurposeModel,
					})
					.then(response => {
						this.pagination = {currentPage: response.data.currentPage, itemsPerPage: response.data.itemsPerPage, consoGroups: response.data.rowSet, totalItems: response.data.totalItems}
						if (store.getters.getCached.page == null) {
							store.getters.getCached.page = {};
						}
						store.getters.getCached.page.pagination = this.pagination;
						this.isLoading = false;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			reset() {
				this.pagination = {currentPage: 1, itemsPerPage: 10, consoGroups: [], totalItems: 0};
				this.sortingModel = {columnName: "x.name", isAscending: true};
				this.filterNameModel = {value: ""};
				this.filterPurposeModel = {value: null};
				this.find(1);
			},
			add() {
				this.$router.push("/admin/consogroup/add");
			},
			view(company: any) {
				this.$router.push("/admin/consogroup/view/" + company.identifier);
			},
			closeDialog() {
				this.isDialogVisible = false;
			},
			exportFile() {
				this.isExporting = false;

				consoGroupApi.consoGroupExportAll({
					filterNameModel: this.filterNameModel,
					filterPurposeModel: this.filterPurposeModel
				})
					.then(response => {
						this.isExporting = false;
					})
					.catch(error => {
						this.isExporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
			importFile(file: any) {
				this.isImporting = true;

				var formData = new FormData();
				formData.append('file', file[0]);

				consoGroupApi.consoGroupImportAll(formData)
					.then((response: any) => {
						this.isImporting = false;
						this.invalidData = response.data;
						this.isDialogVisible = true;
					})
					.catch(error => {
						this.isImporting = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			proceedImport(isOverride: boolean) {
				this.isImporting = true;

				let tempInvalidData = JSON.parse(JSON.stringify(this.invalidData));

				if (isOverride == false && tempInvalidData.warningCount > 0) {
					tempInvalidData.invalidRows.forEach((invalidRow: any, index: any) => {
						if (invalidRow.type == "Warning") {
							invalidRow.type = "Error";
							return invalidRow;
						}
					});
				}

				consoGroupApi.consoGroupImportAllProceed({'invalidData': tempInvalidData})
					.then((response: any) => {
						this.isImporting = false;
						this.$toast.add({severity: "success", summary: "Success", detail: response.message, life: 6000});
						this.isDialogVisible = false;
						this.find(1);
					})
					.catch(error => {
						this.isImporting = false;
						this.isDialogVisible = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					});
			},
		}
	});
</script>
